import { lazy } from "react";
import { Navigate } from "react-router";
import { RequirePermission } from "../components/RequirePermission";
import { Route } from "react-router";
import { StoreRedirect } from "../features/store/StoreRedirect";

const FlowList = lazy(() =>
  import("../features/flows/FlowList").then((m) => ({ default: m.FlowList })),
);
const FlowListRedirect = lazy(() =>
  import("../features/flows/FlowList").then((m) => ({ default: m.FlowListRedirect })),
);
const VoucherPoolsPage = lazy(() =>
  import("../features/flows/vouchers/VoucherPoolsPage").then((m) => ({
    default: m.VoucherPoolsPage,
  })),
);
const PipelinePage = lazy(() =>
  import("../features/crm/pipeline/PipelinePage").then((m) => ({ default: m.PipelinePage })),
);
const LoyaltyPage = lazy(() =>
  import("../features/loyalty/LoyaltyPage").then((m) => ({ default: m.LoyaltyPage })),
);
const ProspectorGate = lazy(() =>
  import("../features/prospector/ProspectorGate").then((m) => ({ default: m.ProspectorGate })),
);
const TargetsPage = lazy(() =>
  import("../features/prospector/TargetsPage").then((m) => ({ default: m.TargetsPage })),
);
const LeadsPage = lazy(() =>
  import("../features/prospector/LeadsPage").then((m) => ({ default: m.LeadsPage })),
);
const CampaignsPage = lazy(() =>
  import("../features/prospector/CampaignsPage").then((m) => ({ default: m.CampaignsPage })),
);
const MessagesPage = lazy(() =>
  import("../features/prospector/MessagesPage").then((m) => ({ default: m.MessagesPage })),
);
const PackagesPage = lazy(() =>
  import("../features/travel/PackagesPage").then((m) => ({ default: m.PackagesPage })),
);
const TripBookingsPage = lazy(() =>
  import("../features/travel/TripBookingsPage").then((m) => ({ default: m.TripBookingsPage })),
);
const GuaranteePage = lazy(() =>
  import("../features/guarantee/GuaranteePage").then((m) => ({ default: m.GuaranteePage })),
);
const SequencesPage = lazy(() =>
  import("../features/sequences/SequencesPage").then((m) => ({ default: m.SequencesPage })),
);
const VerticalPacksPage = lazy(() =>
  import("../features/vertical-packs/VerticalPacksPage").then((m) => ({
    default: m.VerticalPacksPage,
  })),
);
const MyTasksPage = lazy(() =>
  import("../features/tasks/MyTasksPage").then((m) => ({ default: m.MyTasksPage })),
);

const FlowRunsPage = lazy(() =>
  import("../features/flows/runs/FlowRunsPage").then((m) => ({ default: m.FlowRunsPage })),
);

// Route order inside <Route path="/w/:workspaceId"> is preserved: this fragment slots in where it was inline.
export const workspaceSalesRoutes = (
  <>
    <Route
      path="flows"
      element={
        <RequirePermission anyOf={["flows.view"]}>
          <FlowList />
        </RequirePermission>
      }
    />
    <Route
      path="flows/:flowId/runs"
      element={
        <RequirePermission anyOf={["flows.view"]}>
          <FlowRunsPage />
        </RequirePermission>
      }
    />
    <Route path="flows/list" element={<FlowListRedirect />} />
    <Route path="vouchers" element={<VoucherPoolsPage />} />
    {/* OWN-368: the old URL keeps working. */}
    <Route path="flows/vouchers" element={<Navigate to="../vouchers" replace />} />
    <Route path="pipeline" element={<PipelinePage />} />
    <Route path="calendar" element={<MyTasksPage />} />
    <Route path="my-tasks" element={<Navigate to="../calendar" replace />} />
    <Route path="loyalty" element={<LoyaltyPage />} />
    <Route path="prospector" element={<ProspectorGate />}>
      <Route index element={<Navigate to="sources" replace />} />
      <Route path="sources" element={<TargetsPage />} />
      <Route path="targets" element={<Navigate to="../sources" replace />} />
      <Route path="leads" element={<LeadsPage />} />
      <Route path="campaigns" element={<CampaignsPage />} />
      <Route path="messages" element={<MessagesPage />} />
    </Route>
    {/* OWN-418: departures are managed inside Packages; the old list URL redirects. */}
    <Route path="trips" element={<Navigate to="packages" replace />} />
    <Route
      path="trips/packages"
      element={
        <RequirePermission anyOf={["trips.view"]} module="travel">
          <PackagesPage />
        </RequirePermission>
      }
    />
    <Route path="orders-bookings" element={<StoreRedirect to="store/orders" />} />
    <Route
      path="trips/bookings"
      element={
        <RequirePermission anyOf={["trips.view"]} module="travel">
          <TripBookingsPage />
        </RequirePermission>
      }
    />
    <Route path="carts" element={<StoreRedirect to="store/carts" />} />
    <Route path="approvals" element={<StoreRedirect to="store/payments?view=approvals" />} />
    <Route path="sequences" element={<SequencesPage />} />
    <Route path="guarantee" element={<GuaranteePage />} />
    <Route path="vertical-packs" element={<VerticalPacksPage />} />
  </>
);
